import React from 'react';
import PropTypes from 'prop-types';

import Box from '@quintoandar/cozy-core/Box';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const PageWrapper = ({ children }) => (
  <Box
    margin={{ xs: '0', sm: '0 auto' }}
    maxWidth={{ xs: 'none', sm: '500px' }}
    width="100%"
    px={3}
    py={{ xs: 1, sm: 3 }}
  >
    {children}
  </Box>
);

PageWrapper.propTypes = propTypes;

export default PageWrapper;
